import React from 'react';
import useBatteryStatus, {BatteryLevelRating} from '@di-shared/features/diag/battery/useBatteryStatus';
import {ccWebviewUtils} from '@shared/cci/features/webviewUtils';
import {ROUTE_PATHS} from '@di-shared/routes';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {emitEventLog} from '@di-shared/features/analytics';

async function openBatteryEmergencyCallModal() {
  return ccWebviewUtils.openBottomSheetWebViewUrl(ROUTE_PATHS.BOTTOM_SHEET_DIAG_BATTERY_EMERGENCY_CALL.getFullPath());
}

interface RemainingBatteryLifeProps {
  vin: string;
}

function RemainingBatteryLife({vin}: RemainingBatteryLifeProps) {
  const {t} = useInferableTranslation();
  const {level} = useBatteryStatus(vin);
  return (
    <div className="section_container">
      {level?.rating === BatteryLevelRating.GOOD && (
        <>
          <div className="section_container_header">
            <h3 className="title_xxsmall">{t('T30129')}</h3>

            <span className="ic_di_battery">
              <span className="ic ic_battery_empty"></span>
              <span className="ic ic_battery_level ic_battery_high">
                <span className="blind">{t('T30130')}</span>
              </span>
            </span>
          </div>
          <p className="battery_desc">{t('T30131')}</p>
        </>
      )}
      {level?.rating === BatteryLevelRating.NORMAL_GOOD && (
        <>
          <div className="section_container_header">
            <h3 className="title_xxsmall">{t('T30129')}</h3>
            <span className="ic_di_battery">
              <span className="ic ic_battery_empty"></span>
              <span className="ic ic_battery_level ic_battery_middle">
                <span className="blind">{t('T30114')}</span>
              </span>
            </span>
          </div>
          <p className="battery_desc">{t('T30131')}</p>
        </>
      )}
      {level?.rating === BatteryLevelRating.NORMAL_WARNING && (
        <>
          <div className="section_container_header">
            <h3 className="title_xxsmall">{t('T30129')}</h3>
            <span className="ic_di_battery">
              <span className="ic ic_battery_empty"></span>
              <span className="ic ic_battery_level ic_battery_middle">
                <span className="blind">{t('T30114')}</span>
              </span>
            </span>
          </div>
          <p className="battery_desc">{t('T30132')}</p>
        </>
      )}
      {level?.rating === BatteryLevelRating.WARNING && (
        <>
          <div className="section_container_header">
            <h3 className="title_xxsmall">{t('T30129')}</h3>
          </div>
          <p
            className="battery_desc type_warning"
            style={{whiteSpace: 'pre-wrap'}}
          >
            <span className="ic ic_filled_caution_16px"></span>
            {t('T30134')}
          </p>

          <button
            type="button"
            className="btn btn_large btn_filled btn_full type_primary"
            onClick={() => {
              emitEventLog({
                event: 'emergency_call_service',
                interaction_type: 'cta click',
                click_text: t('T30135'),
                click_location: 'body',
              });
              openBatteryEmergencyCallModal();
            }}
          >
            {t('T30135')}
          </button>
        </>
      )}
    </div>
  );
}

export default RemainingBatteryLife;
